module.exports = __webpack_public_path__ + "img/ic-tab-exchange.3cf3da3b.png";